import {put, fork, takeEvery, select} from "redux-saga/effects";
import {Storage, ToStorage} from "./storage";
import {
    AudioAdvertisementTiming,
    AudioAdvertisementTimingAction,
    AudioAdvertisementTimingAddAction
} from "../state/audioadvertisementtiming";
import {AppState} from "../state";

export function* advertisementaudiotiming() {
    yield fork (function *() {
        yield takeEvery<AudioAdvertisementTimingAddAction>( "AudioAdvertisementTimingAdd",function *(data) {
            const  old:AudioAdvertisementTiming[] = yield select((appState:AppState)=> appState.audioAdvertisementTiming);
            let newData = old.filter(i=>  i.id !== data.payload.id || i.slug !== data.payload.slug).concat(data.payload);
            newData = newData.filter(x =>  {
                try {
                    return !x.validTo || new Date(x.validTo) > new Date()
                }
                catch (e)
                {
                    return false;
                }
            })
            yield put<AudioAdvertisementTimingAction>({
                type: "AudioAdvertisementTiming",
                payload: newData
            })
            ToStorage("rczadv2", newData);
        })
    });

    yield fork (Storage, "rczadv2", function*(value: any) {
        if (value && Array.isArray(value)) {

            yield put<AudioAdvertisementTimingAction>({
                type: "AudioAdvertisementTiming",
                payload: value
            })
        } else {
            yield put<AudioAdvertisementTimingAction>({
                type: "AudioAdvertisementTiming",
                payload: []
            })
        }
    });
}

